import { colors } from '../../Colors/colors'

export const pipelineItemScheduling = {
   light: {
      addOrEditScheduleDetails: {
         closeIconColor: colors['gray-500'],
         entityItemTextColor: 'text-gray-700',
         headerBorderColor: 'border-gray-300',
         headerTitleTextColor: 'text-gray-900',
         defaultIconColor: colors['gray-600']
      },

      agentMetricsController: {
         schedulesCardBGColor: 'bg-success-50',
         schedulesIconBGColor: 'bg-success-100',
         overdueCardBGColor: 'bg-warning-50',
         overdueIconBGColor: 'bg-warning-100',
         headingTextColor: 'text-gray-700',
         iconColor: colors['success-600'],
         overDueIconColor: colors['warning-600']
      },
      agentSchedulesDetailedView: {
         defaultBgColor: 'bg-gray-100',
         borderColor: 'border-gray-300',
         schedulesListContainerBgColor: 'bg-base-white'
      },
      agentSidePeek: {
         borderColor: 'border-gray-300'
      },

      agentSidePeekHeader: {
         agentNameColor: 'text-gray-900'
      },
      common: {
         errorMessageTextColor: 'text-error-500',
         errorIconColor: colors['error-500'],
         collapseCardTextColor: 'text-gray-800',
         defaultBGColor: 'bg-white',
         defaultBorderColor: 'border-gray-300',
         chevronIconColor: colors['gray-500']
      },

      completedScheduledList: {
         checkCircleIconColor: colors['gray-500'],
         completedTextColor: 'text-gray-700',
         chevronIconColor: colors['gray-600']
      },

      homeBoardHeader: {
         containerBorderColor: 'border-gray-300',
         boardNameTextColor: 'text-gray-900'
      },
      homeBoardBody: {
         containerBGColor: 'bg-gray-100',
         defaultBGColor: 'bg-white',
         teamMetrics: {
            scheduledCardBGColor: 'bg-success-50',
            scheduledCardIconBGColor: 'bg-success-100',
            scheduledCardIconColor: colors['success-600'],
            overdueCardBGColor: 'bg-warning-50',
            overdueCardIconBGColor: 'bg-warning-100',
            overdueCardIconColor: colors['warning-600'],
            teamMetricsHeaderTextColor: 'text-gray-700',
            skeletonLoaderBaseColor: 'bg-white',
            skeletonLoaderHighlightColor: colors['gray-300']
         }
      },

      pipelineItemSchedulesController: {
         skeletonHighlightColor: colors['gray-100']
      },

      scheduleController: {
         addScheduleTextColor: 'text-primary-600',
         addScheduleCalendarIconColor: colors['primary-600'],
         calenderIconColor: colors['gray-500'],
         deleteIconColor: colors['gray-700'],
         reminderInMinsColor: 'text-gray-500',
         scheduledByHeaderTitleColor: 'text-gray-700',
         scheduledByHeaderTextHighlightBGColor: 'bg-primary-600',
         scheduledDateTimeTextColor: 'text-gray-700',
         meetLinkBgColor: 'bg-primary-25',
         meetLinkColor: 'text-primary-600',
         scheduleTitleColor: 'text-gray-700',
         scheduleTitleLabelColor: 'text-gray-500',
         defaultIconColor: colors['gray-600']
      },

      scheduledStatsDatePicker: {
         chevronIconColor: colors['gray-600'],
         selectedDateTextColor: 'text-gray-700'
      },

      scheduledPipelineItemCard: {
         avatarNameColor: 'text-gray-900',
         timeColor: 'text-gray-600',
         titleColor: 'text-gray-800'
      },
      otherUsersSchedules: {
         userNameColor: 'text-gray-700',
         dateTimeColor: 'text-gray-600',
         horizontalLineBGColor: 'bg-gray-300',
         othersScheduledOnColor: 'text-primary-600',
         chevronIconColor: colors['primary-600']
      },

      notificationCard: {
         calendarIconColor: colors['primary-600'],
         calendarIconContainerBGColor: 'bg-primary-100',
         calendarIconContainerBorderColor: 'border-primary-50',
         cardBGColor: 'bg-base-white',
         cardBorderColor: 'border-gray-100',
         closeIconColor: colors['gray-500'],

         notificationDetails: {
            dateTextColor: 'text-gray-600',
            linkExternalIconColor: colors['primary-600'],
            nameTextColor: 'text-gray-700',
            scheduledAtTextColor: 'text-gray-900'
         }
      },

      schedulesMetrics: {
         descriptionAndCountColor: 'text-gray-600',
         schedulesAndOverdueCountColor: 'text-gray-900',
         scheduledIconBgColor: 'bg-primary-100',
         overdueIconBgColor: 'bg-warning-100'
      },

      suggestedTaskScheduleController: {
         borderBGColor: 'border-gray-300'
      },

      googleCalendar: {
         connectToGoogleCalendar: {
            defaultTextColor: 'text-gray-700',
            descriptionTextColor: 'text-gray-600',
            bgColor: 'base-white',
            borderColor: 'border-gray-300'
         },
         addToGoogleCalender: {
            labelTextColor: 'text-gray-700',
            defaultToggleSwitchBgColor: colors['gray-100'],
            guests: {
               disabledIconColor: colors['gray-300'],
               otherGuestsLabelColor: 'text-gray-500',
               horizontalLineColor: 'bg-gray-200 border-gray-200',
               plusIconColor: colors['primary-600'],
               mailIconColor: colors['gray-500'],
               deleteIconColor: colors['error-700']
            }
         },
         scheduleConflictCard: {
            rightArrowIconColor: colors['primary-700'],
            titleColor: 'text-primary-700',
            descriptionColor: 'text-primary-600',
            infoIconColor: colors['primary-600'],
            borderColor: 'border-primary-300',
            bgColor: 'bg-primary-25'
         }
      },
      errorAlertCard: {
         titleColor: 'text-error-700',
         alertIconColor: colors['error-600'],
         borderColor: 'border-error-300',
         bgColor: 'bg-error-25'
      }
   },

   dark: {
      common: {}
   }
}
